/**
 * `/account/teams`, the favorite teams manager (ISSUE-1399). Named
 * `account_.teams` so it needs no `/account` parent, like `account_.edit`.
 */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { requireSignedIn } from "../auth/requireSignedIn";
import { ACCOUNT_ROUTE } from "../features/editProfile/editProfileLogic";
import {
  TEAMS_HEADING,
  TEAMS_SUB,
} from "../features/favoriteTeams/favoriteTeamsModel";
import { FavoriteTeamsPane } from "../features/favoriteTeams/FavoriteTeamsPane";
import { BackButton } from "../shell/BackLink";
import { SectionScreen } from "../shell/SectionScreen";

const FavoriteTeamsScreen = (): ReactNode => {
  const navigate = useNavigate();
  return (
    <SectionScreen
      heading={TEAMS_HEADING}
      back={
        <BackButton
          label="Account"
          onBack={() => {
            void navigate({ to: ACCOUNT_ROUTE });
          }}
        />
      }
    >
      <p className="text-body text-ink-secondary">{TEAMS_SUB}</p>
      <div className="sm-screen-bottom">
        <FavoriteTeamsPane />
      </div>
    </SectionScreen>
  );
};

export const Route = createFileRoute("/account_/teams")({
  beforeLoad: requireSignedIn,
  component: FavoriteTeamsScreen,
});
